/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    DoorFrontOutlined,
    GroupsOutlined,
    HistoryOutlined,
    QueryStatsOutlined, StarHalfOutlined,
    SupportAgentOutlined,
    TaskOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import fondo from '../Recursos/fondo_sh.mp4'
import fondo_bg from '../Recursos/fondo_bg.png'
import Seccion_Inicio from "./Secciones/Seccion_Inicio";
import Seccion_Dashboard from "./Secciones/Seccion_Dashboard";
import Seccion_Historial from "./Secciones/Seccion_Historial";
import Seccion_Contratos from "./Secciones/Seccion_Contratos";
import Seccion_Equipos from "./Secciones/Seccion_Equipos";
import Seccion_Soporte from "./Secciones/Seccion_Soporte";
import Seccion_Proximamente from "./Secciones/Seccion_Proximamente";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)
    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >

            <video autoPlay muted loop style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100vh',
                objectFit: 'cover',
                objectPosition: 'center',
                overflow: 'hidden'
            }}>
                <source src={fondo} type="video/mp4" poster={fondo_bg}/>
            </video>

            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

        </Grid>
    )

}
export default Dashboard

const secciones = [


    {
        nombre: 'Inicio',
        icono: DoorFrontOutlined,
        camino: '*',
        categoria: 'Plataforma',
        Componente: <Seccion_Inicio/>
    },
    {
        nombre: 'Dashboard',
        icono: QueryStatsOutlined,
        camino: '/Dashboard',
        categoria: 'Personal',
        Componente: <Seccion_Dashboard/>
    },
    {
        nombre: 'Contratos',
        icono: TaskOutlined,
        camino: '/Contratos',
        categoria: 'Personal',
        Componente: <Seccion_Contratos/>
    },
    {
        nombre: 'Equipo',
        icono: GroupsOutlined,
        camino: '/Equipo',
        categoria: 'Personal',
        Componente: <Seccion_Equipos/>
    },
    {
        nombre: 'Historial',
        icono: HistoryOutlined,
        camino: '/Historial',
        categoria: 'Personal',
        Componente: <Seccion_Historial/>
    },
    {
        nombre: 'Proximamente',
        icono: StarHalfOutlined,
        camino: '/Proximamente',
        categoria: 'Personal',
        Componente: <Seccion_Proximamente/>
    },
    {
        nombre: 'Soporte',
        icono: SupportAgentOutlined,
        camino: '/Soporte',
        categoria: 'Personal',
        Componente: <Seccion_Soporte/>
    }
]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}